import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddExpenseModal({ onClose, onSuccess, categories }) {
  const [categoryId, setCategoryId] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/add-expense`, {
        category_id: parseInt(categoryId),
        amount: parseFloat(amount),
        description,
        recorded_by: localStorage.getItem('userId')
      });
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding expense: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Add Expense</h2>
        <form onSubmit={handleSubmit}>
          <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)} required>
            <option value="">Select Category</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <input type="number" step="0.01" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} required />
          <textarea placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} rows="2"></textarea>
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Adding...' : 'Add Expense'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddExpenseModal;